import { IVacancyFullInfo } from '../types/state-types';

const mainContentFields = [
  'isRecommendationAllowed',
  'unpaidRecommendation',
  'responsibilities',
  'descriptionVacancy',
  'requirements',
  'terms',
  'aboutDivision',
  'aboutTeam',
] as const;

const sideContentFields = [
  'city',
  'salaryBracket',
  'workExperience',
  'workFormat',
  'employmentType',
  'grade',
  'schedule',
] as const;

const isMainContentEntry = (
  entry: [keyof IVacancyFullInfo, IVacancyFullInfo[keyof IVacancyFullInfo]],
): entry is [
  keyof IVacancyFullInfo,
  IVacancyFullInfo[(typeof mainContentFields)[number]]
] => (mainContentFields as readonly string[]).includes(entry[0]);

const isSideContentEntry = (
  entry: [keyof IVacancyFullInfo, IVacancyFullInfo[keyof IVacancyFullInfo]],
): entry is [
  keyof IVacancyFullInfo,
  IVacancyFullInfo[(typeof sideContentFields)[number]]
] => (sideContentFields as readonly string[]).includes(entry[0]);

export const filterContent = (vacancy: IVacancyFullInfo | null) => {
  const entries = Object.entries(vacancy ?? {}) as Array<
    [keyof IVacancyFullInfo, IVacancyFullInfo[keyof IVacancyFullInfo]]
  >;

  const mainContent = entries.filter(
    (item) => isMainContentEntry(item)
      && typeof item[1] === 'object'
      && item[1] !== null
      && item[1].value,
  ) as Array<
    [
      (typeof mainContentFields)[number],
      IVacancyFullInfo[(typeof mainContentFields)[number]]
    ]
  >;

  mainContent.sort((a, b) => {
    if (typeof a[1] !== 'boolean' && typeof b[1] !== 'boolean') {
      return a[1].order - b[1].order;
    }

    return 0;
  });

  const sideContent = entries.filter(
    (item) => isSideContentEntry(item)
      && typeof item[1] === 'object'
      && item[1] !== null
      && item[1]?.value
      && (!Array.isArray(item[1].value)
        || (Array.isArray(item[1].value) && item[1].value.length !== 0)),
  ) as Array<
    [
      (typeof sideContentFields)[number],
      IVacancyFullInfo[(typeof sideContentFields)[number]]
    ]
  >;

  return [mainContent, sideContent] as const;
};
